import React, { useState, useEffect } from 'react'
import moment from 'moment';
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import { Button, Box, Typography, TextField } from '@material-ui/core';
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import styled from 'styled-components';
import MaterialTable from 'react-data-table-component';
import CircularProgress from '@material-ui/core/CircularProgress';
import {csrf, headers} from "constants/csrf"
import { flash_alert } from 'components/App';
import { withRouter } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
// import { DateRangePicker } from 'rsuite';
// //import 'rsuite/dist/rsuite.min.css'
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {useTranslation} from "react-i18next"
import i18next from 'i18next';

//(import { DateRangePicker } from 'react-date-range';
////////////////////////////
import { DateRangePicker, DateRange } from "materialui-daterange-picker";
const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";

const ClearButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FilterComponent = ({open, toggle, dateRange, setDateRange, setOpen, filterText, onFilter, onClear, value, setValue, isReadOnly, allDataLoaded, backgroundLoading }) => {
  const { t } = useTranslation;
  function handleDownload() {
    const LIMIT_MONTHS = 2
    const { startDate, endDate } = dateRange
    const diffMonths = moment(endDate).diff(moment(startDate), 'months')
    if (!endDate) {
      flash_alert("Error", "Debes seleccionar fecha fin", "danger")
      return
    }

    if (diffMonths > LIMIT_MONTHS) {
      flash_alert("Error",`El rango de fechas no puede ser mayor a ${LIMIT_MONTHS} meses`, "danger")
      return
    }

    const queryParams = new URLSearchParams();
    queryParams.set('start', startDate);
    queryParams.set('finish', endDate);
    window.location.href = '/api/v1/services_report_excel.xlsx?' + queryParams
  }

  return (
    <React.Fragment>
      <FormControl variant="outlined" className="table-search-form">
      <InputLabel className="white-bg padding-sides-5 table-search-label"  htmlFor="search">
        {i18next.t('globalText.filterFor')}
      </InputLabel>
        <OutlinedInput
          id="search"
          type= "text"
          className="table-search-input"
          value={filterText}
          onChange={onFilter}
          endAdornment={
            <InputAdornment position="end" >
              <IconButton
                  aria-label="toggle password visibility"
                  onClick={onClear}
                  >
                  {<Close />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      {!open && !isReadOnly && (
        <Button onClick={()=>{setOpen(true)}} className="mdl-navigation__link action-plus-btn" variant="outlined" color="primary" >
          <i className="material-icons">date_range</i>&nbsp;&nbsp;
        </Button>
      )}
      {!isReadOnly && (
        <div className='absolute-calentar'>
          <DateRangePicker
            open={open}
            toggle={toggle}
            onChange={(range) => setDateRange(range)}
            initialDateRange = {{
              startDate: dateRange.startDate,
              endDate: dateRange.endDate,
              key: 'selection',
            }}
            maxDate={new Date()}
            minDate={new Date((new Date().getFullYear() - 1), 0, 1)}
          />
        </div>
      )}
      {!isReadOnly && (
        <Button
          className="mdl-navigation__link action-plus-btn"
          // href={"/api/v1/services_report_excel.xlsx?start="+dateRange.startDate+";finish="+dateRange.endDate}
          variant="outlined"
          color="primary"
          onClick={handleDownload}
        >
          <i className="material-icons">download</i>&nbsp;&nbsp;{i18next.t('globalText.downloadServices')}
        </Button>
      )}
      {!isReadOnly && (
        <Button className="mdl-navigation__link action-plus-btn" target="_blank" variant="outlined" color="primary" href={"/data_download"}>
         <i className="material-icons">list</i>&nbsp;&nbsp;{i18next.t('globalText.showDownloads')}
        </Button>
      )}
     </React.Fragment>
  )
}

// Background data loading function that doesn't interfere with main state
function loadBackgroundData(technicianId, isTechnician, dispatch) {
  const endpoint = technicianId
    ? `/api/v1/services/${technicianId}/technician?page=1&per_page=1000`
    : `/api/v1/services?page=1&per_page=1000&keywords=&only_payed=true`;

  return fetch(endpoint)
    .then(response => response.json())
    .then(json => {
      let services = [];
      if (json.data) {
        services = json.data.map(item => {
          if (item.service) {
            return item.service;
          }
          return item;
        });
      } else if (json.services) {
        services = json.services;
      }

      // Update Redux with full dataset for client-side
      const transformedJson = { ...json, data: services };
      dispatch({ type: GET_SERVICES_SUCCESS, json: transformedJson });
      return services;
    })
    .catch(error => {
      console.log('Background loading error:', error);
      return [];
    });
}

function getServices(page = 1, per_page = 5, filterText = "", setLoading, technicianId = null) {
return dispatch => {
    dispatch({type: GET_SERVICES_REQUEST});

    // Use technician-specific endpoint if technicianId is provided
    const endpoint = technicianId
      ? `/api/v1/services/${technicianId}/technician?page=${page}&per_page=${per_page}`
      : `/api/v1/services?page=${page}&per_page=${per_page}&keywords=${filterText}&only_payed=true`;

    return fetch(endpoint)
    .then(response => response.json())
    .then(json => dispatch(getServicesSuccess(json, setLoading)))
    .catch(error => console.log(error));
    };
};export function getServicesSuccess(json, setLoading) {
    setLoading(false)

    // Transform the nested structure to a flat services array
    let services = [];

    if (json.data) {
      services = json.data.map(item => {
        // If the item has a 'service' property (calendar event), extract it
        if (item.service) {
          return item.service;
        }
        // Otherwise, assume it's already a service object
        return item;
      });
    } else if (json.services) {
      services = json.services;
    }

    // The Redux reducer expects the services array in the 'data' property
    const transformedJson = {
      ...json,
      data: services
    };

    return {
      type: GET_SERVICES_SUCCESS,
      json: transformedJson
    };
};

function Services(props){
  const {t} = useTranslation();

  const isTechnician = (user) => {
    return user && (
      user.get_roles_list?.includes('Técnico') ||
      user.get_roles_names?.includes('Técnico')
    );
  };

  const [value, setValue] = React.useState([new Date('2017-02-01'), new Date('2017-05-20')]);
  const [servicesLoading, setServicesLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerpage] = useState(10);
  const [allDataLoaded, setAllDataLoaded] = useState(false); // Track if we've loaded all data
  const [backgroundLoading, setBackgroundLoading] = useState(false); // Track background loading

  const [serviceNumberSearch, setServiceNumberSearch] = useState('');
  const [customerNameSearch, setCustomerNameSearch] = useState('');
  const [searchResults, setSearchResults] = useState(null); // null = not in search mode
  const [searchLoading, setSearchLoading] = useState(false);

  // Check if this is a technician-specific route
  const urlParams = new URLSearchParams(props.location?.search || '');
  const technicianIdFromUrl = urlParams.get('technician_id');
  const searchFromUrl = urlParams.get('search') || '';

  const [filterText, setFiltertext] = useState(searchFromUrl);
  const [open, setOpen] = React.useState(false);
  const [dateRange, setDateRange] = React.useState({
    startDate: new Date(new Date().setMonth(new Date().getMonth()-1)),
    endDate: new Date(),
    key: 'selection',
  });

  // For technician users, always use their technician ID, ignore URL parameters
  const technicianId = isTechnician(props.current_user)
    ? props.current_user.technician_id
    : (technicianIdFromUrl ||
        (props.match && props.match.params && props.match.params.technician_id
          ? props.match.params.technician_id
          : null));

  // Client-side filtering function
  const filterServices = (services, searchText) => {
    if (!searchText || searchText.trim() === '') {
      return services;
    }

    const search = searchText.toLowerCase().trim();
    return services.filter(service => {
      return (
        (service.number && service.number.toLowerCase().includes(search)) ||
        (service.ibs_number && service.ibs_number.toLowerCase().includes(search)) ||
        (service.customer_name && service.customer_name.toLowerCase().includes(search)) ||
        (service.service_type && service.service_type.toLowerCase().includes(search)) ||
        (service.subcategory && service.subcategory.toLowerCase().includes(search)) ||
        (service.status && service.status.toLowerCase().includes(search)) ||
        (service.request_channel && service.request_channel.toLowerCase().includes(search))
      );
    });
  };

  // Apply client-side filtering to services
  const filteredServices = filterServices(props.allServices, filterText);

  const toggle = () => setOpen(!open);

  const service_columns = [
    {
      name: t('globalTables.serviceColumns.number'),
      selector: 'number',
      sortable: true,
      grow: true,
      minWidth: "110px",
      cell: row => (
        <span>
          {(row.number == "" ? "-" : row.number)}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.ibsNumber'),
      selector: 'ibs_number',
      sortable: true,
      hide: 'sm',
      cell: row => (
        <span>
          {(!row.ibs_number ? t('globalText.noInfo') : row.ibs_number)}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.serviceType'),
      selector: 'service_type',
      sortable: true,
      cell: row => (
        <span>
          {(!row.service_type || row.service_type === "" ?
            t('globalText.noInfo') :
            t(`services.indexRow.serviceType.${row.service_type}`)
          )}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.subCategory'),
      selector: 'subcategory',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
          {(!row.subcategory ? t('globalText.noInfo') : t(`services.indexRow.subCategory.${row.subcategory}`))}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.requested'),
      selector: 'requested',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
        {
          (
            (!row.requested) ? t('globalText.noInfo') :
            (row.requested.toLowerCase() == t("services.authorizedDealer") ? row.distributor_name +" "+ row.distributor_email : t(`services.indexRow.requested.${row.requested}`))
          )
        }
        </span>
      ),
    },
    {
        name: t('globalTables.serviceColumns.customerFullName'),
        selector: 'customer_fullname',
        sortable: true,
        hide: 'md'
    },
    {
      name: t('globalTables.serviceColumns.requestChannel'),
      selector: 'request_channel',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
          {(!row.request_channel || row.request_channel === "" ?
            t('globalText.noInfo') :
            t(`services.indexRow.request_channel.${row.request_channel}`)
          )}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.statusLabel'),
      selector: 'status_label',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
          {(!row.status || row.status === "" ?
            t('globalText.noInfo') :
            t(`services.indexRow.status.${row.status}`)
          )}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.visitNumber'),
      selector: 'visit_number',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
          {(!row.visit_number ? t('globalText.noInfo') : row.visit_number)}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.updatedAt'),
      selector: 'updated_at',
      sortable: true,
      hide: 'md',
      cell: row => (
        <span>
          {(!row.updated_at ?
            t('globalText.noInfo') :
           moment(row.updated_at, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm')
          )}
        </span>
      ),
    },
    {
      name: t('globalTables.serviceColumns.actions'),
      selector: 'id',
      grow: true,
      minWidth: "120px",
      cell: row => {
        return (
          <div>
              <Link className="mdl-navigation__link brand-primary-link customers-show-link services-show-link mg-r-15" to={`/customers/${row.customer_id || 'unknown'}/services/${row.id}/edit_service`}>
                <i className="material-icons material-icons-20">assignment</i> {t("globalText.details")}
              </Link>
          </div>
        );
      },
    },
];

  //const [selectedRows, setSelectedRows] = useState([]);

  function handleSelect(ranges){
    console.log(ranges);
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
  }

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }

  useEffect(() => {
    async function fetchData() {
        setServicesLoading(true);
        setAllDataLoaded(false);

        // Always start with server-side pagination for fast initial load
        await props.getServices(1, perPage, "", setServicesLoading, technicianId);

        // After initial load, fetch all data in background for client-side operations
        if (!backgroundLoading) {
          setBackgroundLoading(true);
          setTimeout(async () => {
            try {
              await loadBackgroundData(technicianId, isTechnician(props.current_user), props.dispatch);
              setAllDataLoaded(true);
              setBackgroundLoading(false);
            } catch (error) {
              console.error('Background data loading failed:', error);
              setBackgroundLoading(false);
            }
          }, 1000); // Increased delay to ensure initial load completes
        }
    }
    fetchData();
  }, [technicianId, props.location?.search]);

  useEffect(() => {
    // The filtering happens automatically when filterText changes via filteredServices
  }, [filterText, technicianId, props.location?.search])

  // Watch for URL changes and update filterText when search parameter changes
  useEffect(() => {
    const urlParams = new URLSearchParams(props.location?.search || '');
    const searchFromUrl = urlParams.get('search') || '';
    if (searchFromUrl !== filterText) {
      setFiltertext(searchFromUrl);
      if (allDataLoaded) {
        setPage(1);
      }
    }
  }, [props.location?.search, allDataLoaded]);

  async function handlePageChange(newPage){
    setPage(newPage);
    // Only make server calls if we haven't loaded all data yet
    // Once all data is loaded, client-side pagination is handled by MaterialTable automatically
    if (!allDataLoaded && !backgroundLoading) {
      setServicesLoading(true);
      props.getServices(newPage, perPage, "", setServicesLoading, technicianId);
    }
  }

  async function handlePerRowsChange(newPerPage, newPage){
    setPerpage(newPerPage);
    setPage(newPage);

    if (!allDataLoaded && !backgroundLoading) {
      setServicesLoading(true);
      props.getServices(newPage, newPerPage, "", setServicesLoading, technicianId);
    }
  }

  function handleChange(state){
   setSelectedRows(state.selectedRows);
  }

  function handleClear(){
    setFiltertext("");
    if (allDataLoaded) {
      setPage(1);
    }
  }

  async function changeFilterText(e){
    setFiltertext(e.target.value);
    if (allDataLoaded) {
      setPage(1);
    }
  }

  async function changeRange(range){
    setDateRange(range);
  }

  async function handleServerSearch(keywords) {
    if (!keywords || !keywords.trim()) return;
    setSearchLoading(true);
    try {
      const response = await fetch(`/api/v1/services?page=1&per_page=100&keywords=${encodeURIComponent(keywords.trim())}&only_payed=true`);
      const json = await response.json();
      let services = [];
      if (json.data) {
        services = json.data.map(item => (item.service ? item.service : item));
      } else if (json.services) {
        services = json.services;
      }
      setSearchResults(services);
    } catch (error) {
      flash_alert("Error", t('globalText.searchError'), "danger");
    } finally {
      setSearchLoading(false);
    }
  }

  function handleClearSearch() {
    setServiceNumberSearch('');
    setCustomerNameSearch('');
    setSearchResults(null);
  }

  const tableData = searchResults !== null ? searchResults : filteredServices;

  return (
    <React.Fragment>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap' }}>
        <TextField
          label={t('globalText.searchByServiceNumber')}
          variant="outlined"
          size="small"
          value={serviceNumberSearch}
          onChange={e => setServiceNumberSearch(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleServerSearch(serviceNumberSearch); }}
          style={{ minWidth: '220px' }}
          disabled={searchLoading}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleServerSearch(serviceNumberSearch)}
          disabled={searchLoading || !serviceNumberSearch.trim()}
          startIcon={searchLoading ? <CircularProgress size={16} /> : <SearchIcon />}
        >
          {t('globalText.search')}
        </Button>

        <TextField
          label={t('globalText.searchByCustomerName')}
          variant="outlined"
          size="small"
          value={customerNameSearch}
          onChange={e => setCustomerNameSearch(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleServerSearch(customerNameSearch); }}
          style={{ minWidth: '220px' }}
          disabled={searchLoading}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleServerSearch(customerNameSearch)}
          disabled={searchLoading || !customerNameSearch.trim()}
          startIcon={searchLoading ? <CircularProgress size={16} /> : <SearchIcon />}
        >
          {t('globalText.search')}
        </Button>

        {searchResults !== null && (
          <Button
            variant="outlined"
            onClick={handleClearSearch}
            startIcon={<Close />}
          >
            {t('globalText.clearSearch')} ({searchResults.length})
          </Button>
        )}
      </div>

      <MaterialTable
        title={t('services.title')}
        columns={service_columns}
        data={tableData}
        progressPending={servicesLoading}
        progressComponent={<CircularProgress size={50} />}
        pagination
        paginationServer={searchResults === null && !allDataLoaded}
        responsive={true}
        paginationTotalRows={searchResults !== null ? searchResults.length : (allDataLoaded ? filteredServices.length : props.total)}
        paginationPerPage={perPage}
        paginationDefaultPage={page}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        onSelectedRowsChange={handleChange}
        highlightOnHover={true}
        striped={true}
        noDataComponent={i18next.t('globalText.NoDataComponent')}
        paginationComponentOptions={{rowsPerPageText: i18next.t('globalText.rowsPerPageText'), rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'), noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText') }}
        subHeader
        subHeaderComponent={<FilterComponent open={open} toggle={toggle} dateRange={dateRange} setDateRange={setDateRange} setOpen={setOpen} value={value} setValue={setValue} onFilter={changeFilterText} onClear={handleClear} filterText={filterText} isReadOnly={isTechnician(props.current_user)} allDataLoaded={allDataLoaded} backgroundLoading={backgroundLoading} />}
      />

    </React.Fragment>
  );

}
//  onClick={()=> this.props.getUsers() }

Services.propTypes = {
  services: PropTypes.array,
  page: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number
};

const structuredSelector = createStructuredSelector({
  services: state => {
    // The services should now be stored directly in state.services since we fixed the reducer data
    const services = state.services || [];
    return services;
  },
  allServices: state => state.services || [], // Keep all services for filtering
  page: state => state.services_page,
  perPage: state => state.services_per_page,
  total: state => state.services_total,
  current_user: state => state.current_user
});
const mapDispatchToProps = (dispatch) => ({
  getServices: (page, per_page, filterText, setLoading, technicianId) =>
    dispatch(getServices(page, per_page, filterText, setLoading, technicianId)),
  dispatch
});
export default withRouter(connect(structuredSelector, mapDispatchToProps)(Services));
